import { Typography } from '@bgzt/ui';

import { Spacing, ProductListTemp, ProductItem, LogImpression, LogClick, LinkByEnvironment } from '~/components';
import { ProductDataV2 } from '~/apis/search';

import { CONTENT_TYPE, EVENT_ACTION, EVENT_TYPE, PAGE_ID, VIEW_ID } from '~/apis/log/constant';
import { PRODUCT_DETAIL_SNACKBAR_BOTTOM_OFFSET } from '~/app/products/[pid]/_components/constants';
import { sendLog } from '~/apis/log';

type Props = {
  pid: number;
  categoryName?: string;
  categoryProducts?: ProductDataV2[];
};

export const CategoryProducts = ({ pid, categoryName, categoryProducts }: Props) => {
  if (!categoryProducts) return null;
  return (
    <>
      <Spacing height={30} />
      <Typography variant="S1" color="gray-900">
        {`${categoryName}의 최신 상품`}
      </Typography>

      <Spacing height={12} />

      <ProductListTemp col={3}>
        {categoryProducts?.map((product, index) => {
          const path = `/products/${product.pid}`;
          const logParams = {
            page_id: PAGE_ID.PRODUCT,
            view_id: VIEW_ID.PRODUCT,
            page_label: pid.toString(),
            content_id: String(product.pid),
            content_type: CONTENT_TYPE.MERCARI,
            content_position: index,
            tracking: product?.tracking,
          };
          return (
            <li key={product.pid}>
              <LogImpression
                params={{
                  ...logParams,
                  event_type: EVENT_TYPE.IMPRESSION,
                  event_action: EVENT_ACTION.IMPRESSION,
                }}
              >
                <LogClick
                  params={{
                    ...logParams,
                    event_type: EVENT_TYPE.SELECT_PRODUCT,
                    event_action: EVENT_ACTION.SELECT_PRODUCT,
                  }}
                >
                  <LinkByEnvironment href={path} target={'_self'}>
                    <ProductItem
                      key={product.pid}
                      pid={Number(product.pid)}
                      image={product.productImage}
                      name={product.name}
                      location={product.location}
                      updatedBefore={product.updatedBefore}
                      price={product.price}
                      status={product.status}
                      faved={product.faved}
                      discountRate={product.discount?.rate}
                      viewType="3-column"
                      onFavoriteClick={(value) => {
                        sendLog({
                          ...logParams,
                          event_type: EVENT_TYPE.WISHLIST,
                          event_action: value ? EVENT_ACTION.ADD_TO_WISHLIST : EVENT_ACTION.REMOVE_FROM_WISHLIST,
                        });
                      }}
                      snackbarBottomOffset={PRODUCT_DETAIL_SNACKBAR_BOTTOM_OFFSET}
                    />
                  </LinkByEnvironment>
                </LogClick>
              </LogImpression>
            </li>
          );
        })}
      </ProductListTemp>
    </>
  );
};
